import React from 'react';

import { Grid } from '@gogame/components';
import { withArrayFormField } from '@gogame/form';

import { CAMPAIGN_COST_MODELS } from 'scenes/Campaigns/components/Form/Campaign/constants';
import { CostModels } from './CostModels';

const EMPTY_CAMPAIGNS = [];
const EMPTY_PLATFORMS = [];

export const MultiCampaignsCostModels = withArrayFormField()(({
  name,
  value = EMPTY_CAMPAIGNS,
  platforms = EMPTY_PLATFORMS,
  CostModelFormCreate,
  CostModelFormEdit,
  removableCostModels,
}) => {
  return (
    <Grid container spacing={3}>
      {value.map((_, i) => {
        const platformName = value.length > 1 ? platforms?.[i]?.name : '';
        return (
          <Grid item xs={12 / value.length} key={i}>
            <CostModels
              platformName={platformName}
              canAddCostModel={true}
              name={`${name}[${i}].${CAMPAIGN_COST_MODELS}`}
              CostModelFormCreate={CostModelFormCreate}
              CostModelFormEdit={CostModelFormEdit}
              fullWidthItem={value.length > 1}
              removableCostModels={removableCostModels}
            />
          </Grid>
        );
      })}
    </Grid>
  );
});
